import React from 'react'
import "./SliderItem.css"

const SliderItem = ({ title, image, description }) => {
  return (
    <div className="sliderCard">

      <div className="sliderImage">
        <img src={image} alt={title} />
      </div>

      <div className="sliderContent">
        <h3 className="productName">{title}</h3>
        <p className="productReview">{description}</p>
      </div>

    </div>
  )
}

export default SliderItem